export default __webpack_public_path__ + "static/media/signInImage.eeb0c777.png";